import { SubtitleCue } from "./types";

/**
 * Finds the current subtitle cue for a given time
 * Uses binary search for O(log n) performance
 */
export function getCurrentCue(cues: SubtitleCue[] | undefined, currentTime: number): SubtitleCue | null {
  if (!cues || cues.length === 0) return null;

  // Binary search for the cue containing currentTime
  let low = 0;
  let high = cues.length - 1;

  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    const cue = cues[mid];

    if (currentTime >= cue.start && currentTime <= cue.end) {
      return cue;
    }

    if (currentTime < cue.start) {
      high = mid - 1;
    } else {
      low = mid + 1;
    }
  }

  return null;
}

